import React from "react";
import { Link } from "react-router-dom";

const ShippingDelivery = () => {
  return (
    <>
      <section className="pt-[180px] max-md:pt-[130px] pb-[80px] relative max-lg:bg-[right_center] bg-[#f4f4f4] about-banner overflow-hidden">
        <div className="container">
          <div className="row items-center">
            <div className="w-full">
              <div className="relative max-md:text-center">
                <h2 className="text-[92px] max-md:text-[50px] font-bold capitalize font-sora text-secondary leading-[1.2]">
                  Shipping and Delivery
                </h2>
                <img
                  src="assets/img/shap-three-1.png"
                  alt="banner-shap"
                  className="absolute w-46 w-35 -top-[30px] -left-[32px] max-md:hidden  animate-topshap"
                />
              </div>
              <ol className="mb-[16px] flex items-center max-md:justify-center max-md:mb-[40px] pt-[20px] max-md:hidden">
                <li className="text-[22px] text-secondary font-sora capitalize">
                  <Link to="/"> Home </Link>
                </li>
                <li
                  className="text-[22px] text-gary capitalize before:content-['-'] before:float-left before:text-gary before:px-[10px]"
                  aria-current="page"
                >
                  Shipping and Delivery Policy
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section id="h4-pricing" className="relative w-full overflow-hidden">
        <div className="w-full h4-pricing-wrapper max-md:px-[30px] pb-[80px] md:pb-[80px] max-md:pt-[60px] md:pt-[80px] pricing_section_bg">
          <div className="theme-container mx-auto">
            <div className="w-full">
              <div className="md:px-[100px]">
                <ul>
                  <li>
                    1. Service orders are fulfilled by our empaneled health
                    providers through their qualified technicians or
                    phlebotomist or staff.
                  </li>
                  <li>
                    2. Product orders are shipped through registered domestic
                    courier companies and /or speed post only.
                  </li>
                  <li>
                    3. Orders are shipped within 0-7 days or as per the delivery
                    date agreed at the time of order confirmation and delivering
                    of the shipment subject to Courier Company / post office
                    norms.
                  </li>
                  <li>
                    4. We are not liable for
                    any delay in delivery by the courier company / postal
                    authorities and only guarantees to hand over the consignment
                    to the courier company or postal authorities within 0-7 days
                    rom the date of the order and payment or as per the delivery
                    date agreed at the time of order confirmation.
                  </li>
                  <li>
                    5. Delivery of all orders will be to the address provided by
                    the buyer.
                  </li>
                  <li>
                    6. Delivery of our services will be confirmed on your mail
                    ID as specified during registration. For any issues in
                    utilizing our services you may contact our helpdesk on
                    <a href="tel:91" style={{ display: "inline" }}>
                      +91 9616022044
                    </a>
                    or
                    <a
                      href="mailto:"
                      style={{ display: "inline" }}
                    >
                      care@curepointopd.in
                    </a>
                    .
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="shape-1 absolute left-40 top-96 z-10">
            <img src="assets/images/home-four/shape-1.webp" alt="" />
          </div>
          <div className="shape-2 absolute right-96 top-96 z-10">
            <img src="assets/images/home-four/shape-2.webp" alt="" />
          </div>
          <div className="shape-3 absolute left-96 top-[550px] z-10">
            <img src="assets/images/home-four/shape-3.webp" alt="" />
          </div>
          <div className="shape-4 absolute right-96 top-[550px] z-10">
            <img src="assets/images/home-four/shape-4.webp" alt="" />
          </div>
        </div>
      </section>

    </>
  );
};

export default ShippingDelivery;
